"use client";

import { ProgressProvider } from "@bprogress/next/app";

function ProgressBarProvider({ children }: { children: React.ReactNode }) {
  return (
    <ProgressProvider
      height="4px"
      color="#22c55e"
      options={{ showSpinner: false }}
      shallowRouting
    >
      {children}
    </ProgressProvider>
  );
}

export default ProgressBarProvider;
